import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type SendIconProps = IconProps;

export const SendIcon: FC<SendIconProps> = ({ iconColor = '#ffffff', className, ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    width="19"
    {...props}
    fill="none"
    height="18"
    viewBox="0 0 19 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.4148 10.2501L17.1648 1.50014M8.52112 10.5235L10.7112 16.1552C10.9042 16.6513 11.0006 16.8994 11.1396 16.9718C11.2601 17.0346 11.4037 17.0347 11.5242 16.972C11.6633 16.8998 11.7601 16.6518 11.9536 16.1559L17.4456 2.08281C17.6202 1.63516 17.7076 1.41133 17.6598 1.26831C17.6183 1.1441 17.5208 1.04663 17.3966 1.00514C17.2536 0.957356 17.0298 1.0447 16.5821 1.21939L2.50902 6.71134C2.01312 6.90486 1.76517 7.00163 1.69292 7.14071C1.63028 7.26129 1.63036 7.40483 1.69314 7.52533C1.76556 7.66433 2.01362 7.7608 2.50975 7.95373L8.14142 10.1438C8.24212 10.183 8.29248 10.2026 8.33488 10.2328C8.37246 10.2596 8.40532 10.2925 8.43213 10.3301C8.46237 10.3725 8.48196 10.4228 8.52112 10.5235Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
